/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import Dashboardheader from "./common/Dashboardheader";
import React, { useState, useEffect } from "react";
import googlePlusIcon from "/public/assets/images/flat-color-iconsgoogle.png";
import FacebookIcon from "/public/assets/images/brandicofacebook-rect.png";
// import ReactDOM from 'react-dom';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
// import {FacebookLogin} from 'react-facebook-login';
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { handleGoogleLogin, handleLogin, handleFBLogin } from "../store/actions/authAction";
import { useRouter } from "next/router";
import { useSession, signIn, signOut } from "next-auth/react";




// import NextAuth from "next-auth";
// import GoogleProvider from "next-auth/providers/google";
// import { handleLogin } from "../utilities/socialAuthCredential";
// import FacebookProvider from "next-auth/providers/facebook";
// providers: [
//   FacebookProvider({
//     clientId: process.env.FACEBOOK_CLIENT_ID,
//     clientSecret: process.env.FACEBOOK_CLIENT_SECRET
//   })
// ]

// ReactDOM.render(
//   <GoogleLogin
//     clientId="167346180228-d4pdi3hpfpqs4t357u82tke2t04s2jrc.apps.googleusercontent.com"
//     render={renderProps => (
//       <button onClick={renderProps.onClick} disabled={renderProps.disabled}>This is my custom Google button</button>
//     )}
//     buttonText="Se connecter"
//     onSuccess={responseGoogle}
//     onFailure={responseGoogle}
//     cookiePolicy={'single_host_origin'}
//   />,
//   document.getElementById('googleButton')
// );

// ReactDOM.render(
//   <FacebookLogin
//     appId="909675826412012"
//     autoLoad={true}
//     fields="name,email,picture"
//     onClick={componentClicked}
//     callback={responseFacebook} />,
//   document.getElementById('demo')
// );

function useWindowSize() {

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}



const schema = Yup.object().shape({
  email: Yup.string()
    .required("Mot de passe nécessaire")
    .email("Invalid email format"),
  password: Yup.string()
    .required("Mot de passe nécessaire")
    .min(8, "Password must be at least 8 characters"),
});

const login = () => {
  const [googleFlag, setGoogleFlag] = useState(false)
  const [count, setCount] = useState(0)
  const { data: session } = useSession();
  // console.log("email data", session?.user)



  // useEffect(() => {
  //   if (session) return Router.push('/');
  // }, [session])

  // if (session) return Router.push('/');


  const size = useWindowSize();
  const dispatch = useDispatch();
  const responseGoogle = (response) => {
    console.log('success', response);
    setGoogleFlag(!googleFlag)
  }
  const responseGoogleError = (response) => {
    console.log('error', response);
  }
  function responseFacebook(response) {
    console.log(response);


    const { email, name, picture, userID } = response;
    dispatch(handleFBLogin({ email, name, picture, userID }));

  }
  const componentClicked = (response) => {
    console.log(response)
  }
  const logout = (response) => {
    console.log(response, 'this is for Déconnexion')
    setGoogleFlag(!googleFlag)
  }


  var info = useSelector((state) =>
    state.auth
      ? state.auth
      : []
  );


  useEffect(() => {
    if (!info || info.isLoggedIn || !session) {
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setCount(count += 1);
    const { email, name, image } = session?.user;
    dispatch(handleGoogleLogin({ email, name, image, count }));

  }, [dispatch, info, session]);

  // console.log(info, 'authauth')

  // if (session) {
  //   
  //   ;
  //   (
  //     <div >
  //       Welcome user<br />
  //       <button onClick={() => signOut()}>Sign out</button>
  //     </div>
  //   );
  // }
  return (
    <div
      className="MapContent navbartopmargin bg"
      style={{ minHeight: size.height }}
    >
      <Head>
        <title>Residen | Se connecter</title>
      </Head>
      <Dashboardheader />
      <div className="container pt-4 pb-4">
        <div className="height d-flex justify-content-center align-items-center">
          <div className="form-main-box">
            <div className="socialIcons mb-4">

              <button type="button" className="btn frm-btn-google" onClick={() => signIn()} style={{ width: "150px" }} >
                <span>
                  <Image src={googlePlusIcon} />
                </span>{" "}
                Google
              </button>
              <FacebookLogin
                appId="3123350514594094"
                // autoLoad={true}
                fields="name,email,picture"
                onClick={componentClicked}
                callback={responseFacebook}
                cssClass="btn frm-btn-facebook"
                icon={<Image src={FacebookIcon} />}
                textButton="&nbsp;&nbsp;Facebook"
              />

              {/* <button onClick={() => signIn()}>Sign in</button> */}
              {/* {
                !googleFlag ?

                  <GoogleLogin
                    clientId={'567557548753-pp966qgof9cb68sde32henlpp5tlo294.apps.googleusercontent.com'}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogleError}
                    cookiePolicy={'single_host_origin'}
                  >
                    <span> Se connecter with Google</span>
                  </GoogleLogin> :
                  <GoogleLogout
                    clientId={"567557548753-pp966qgof9cb68sde32henlpp5tlo294.apps.googleusercontent.com"}
                    buttonText={"Logout"}
                    onLogoutSuccess={logout}
                  >
                    <span> Logout</span>
                  </GoogleLogout>
              } */}




              {/* <button type="button" className="btn frm-btn-facebook" onClick={() => signIn()}>
                <span>
                  <Image src={FacebookIcon} />
                </span>{" "}
                Facebook
              </button> */}
             
            </div>
            <Formik
              validationSchema={schema}
              initialValues={{ email: "", password: "" }}
              validate={(values) => {
                const errors = {};
                return errors;
              }}
              onSubmit={(values) => {
                const { email, password } = values;
                dispatch(handleLogin({ email, password }));
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isvalid,
                /* and other goodies */
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      placeholder="Email ou téléphone"
                      className="form-control inp_text"
                      id="email"
                    />
                    <span className="error text-danger">
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  <div className="mb-4">
                    <input
                      type="password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      placeholder="Mot de passe"
                      className="form-control"
                    />
                    <span className="error text-danger">
                      {errors.password && touched.password && errors.password}
                    </span>
                  </div>
                  <div className="mb-4">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="def_btn btn frm-btn-cmn"
                    >
                      Se connecter
                    </button>
                  </div>
                </form>
              )}
            </Formik>
            {/* <div className="input-group mb-4">
              <input
                type="email"
                className="form-control"
                placeholder="Email ou téléphone"
              />
            </div>
            <div className="input-group mb-4">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
              />
            </div>
            <div className="input-group mb-4">
              <button className="btn frm-btn-cmn" type="submit">
                Log in
              </button>
            </div> */}
            <div className="input-group justify-content-center frgt-text">
              <Link href="/forgotpassword">Mot de passe oublié ?</Link>
            </div>
            <hr />
            <button className="btn frm-btn-cmn mt-2" type="button">
              <Link href="/register">{`S'inscrire`}</Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default login;